import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import { Autocomplete, IconButton, TextField, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import { Stack } from "@mui/system";
import SearchIcon from "@mui/icons-material/Search";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../../assets/styles/tokens";
// ─────────────────────────────────────────────────────────────────────────────

const Puller = styled("div")(({ theme }) => ({
  width: spacing.Spacing["4xl"].$value,
  height: spacing.Spacing.xs.$value,
  backgroundColor: colors.GrayLightMode[300].$value,
  borderRadius: spacing.Radius.xs.$value,
  position: "absolute",
  top: spacing.Spacing.xl.$value,
  left: "calc(50% - 15px)",
  ...theme.applyStyles("dark", {
    backgroundColor: colors.GrayLightMode[300].$value,
  }),
}));

// ─────────────────────────────────────────────────────────────────────────────

export default function ClicksWithFtdSearch() {
  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen: boolean) => () => {
    setOpen(newOpen);
  };

  const brandName = [
    { label: "Brand 01" },
    { label: "Brand 02" },
    { label: "Brand 03" },
    { label: "Brand 04" },
  ];

  const ShortList = (
    <Box role="shortBy">
      <Puller />
      <Stack justifyContent="end" direction="row" p={1}>
        <IconButton
          aria-label="Close"
          onClick={toggleDrawer(false)}
          sx={{
            width: spacing.Spacing["3xl"].$value,
            height: spacing.Spacing["3xl"].$value,
            color: colors.GrayLightMode[700].$value,
          }}
        >
          <CloseIcon />
        </IconButton>
      </Stack>

      <Typography
        variant="body1"
        sx={{
          fontSize: typography.Size.Text.sm.$value,
          color: colors.GrayLightMode[700].$value,
        }}
      >
        Search Brand Name
      </Typography>

      <Box mt={spacing.Spacing.md.$value} sx={{ minHeight: "15rem" }}>
        <Autocomplete
          id="assetOrSiteName"
          disablePortal
          fullWidth
          options={brandName}
          getOptionLabel={(option) => option.label}
          size="small"
          renderInput={(params) => (
            <TextField
              color="secondary"
              {...params}
              required
              placeholder="Search Brand Name"
              //label="Brand Name"
              sx={{
                "& .MuiInputBase-root": {
                  borderRadius: 2,
                },
              }}
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <SearchIcon
                      sx={{
                        fontSize: typography.Size.Text.xl.$value,
                        mr: 1,
                        color: "text.secondary",
                      }}
                    />
                    {params.InputProps.startAdornment}
                  </>
                ),
              }}
            />
          )}
        />
      </Box>
    </Box>
  );

  return (
    <>
      <IconButton color="secondary" size="large" onClick={toggleDrawer(true)}>
        <SearchIcon sx={{ color: colors.GrayLightMode[700].$value }} />
      </IconButton>

      <Drawer
        anchor="bottom"
        open={open}
        onClose={toggleDrawer(false)}
        PaperProps={{
          sx: {
            borderTopLeftRadius: spacing.Radius.xl.$value,
            borderTopRightRadius: spacing.Radius.xl.$value,
            p: spacing.Spacing.xl.$value + "!important",
          },
        }}
      >
        {ShortList}
      </Drawer>
    </>
  );
}
